import { render, staticRenderFns } from "./Btn.vue?vue&type=template&id=4647d7dd&scoped=true"
import script from "./Btn.vue?vue&type=script&lang=js"
export * from "./Btn.vue?vue&type=script&lang=js"
import style0 from "./Btn.vue?vue&type=style&index=0&id=4647d7dd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4647d7dd",
  null
  
)

export default component.exports